"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateNodeByStatus = exports.getStatusPath = void 0;
const parse_task_status_1 = require("./parse-task-status");
/**
 * Replace old `rootNode` from status if it does not match.
 */
function getStatusPath(status, workflow) {
    if (typeof status === 'undefined' || !workflow) {
        return status;
    }
    // prepend rootNode to status value if it does not match
    const rootNode = `/${workflow.stateNode.name}/`;
    const taskStatus = status.startsWith(rootNode)
        ? status
        : rootNode + parse_task_status_1.parseTaskStatus(status);
    return taskStatus;
}
exports.getStatusPath = getStatusPath;
/**
 * Get StateNode based on `task.status` (wrapper for `workflow.getState(status)`).
 *
 * Handles possible old `rootNode` values when Workflow gets renamed.
 */
function getStateNodeByStatus(status, workflow) {
    const taskStatus = getStatusPath(status, workflow);
    return workflow && typeof taskStatus === 'string'
        ? workflow.getState(taskStatus)
        : undefined;
}
exports.getStateNodeByStatus = getStateNodeByStatus;
//# sourceMappingURL=get-state-node-by-status.js.map